export default __webpack_public_path__ + "static/media/tAntlysisLogo.8d4d6260.png";